export const euColor = "#0047ba";
export const worldColor = "#0099a8";

export const keys = [
	{ name: "euTradeValue", color: euColor },
	{ name: "worldTradeValue", color: worldColor },
];
